import React from "react";


const StepTitle = ({ title }) => {
    return(
        <>
        <section className="">
        <div className="container">
          <div className="d-flex mb-md-5">
            <div className="m-auto">
              {/* <h3 class="page-title">BOIS DE CONSTRUCTION</h3>
              <div className="breadcrumbss">
                <Link to='/'>
                  <div className="breadcrumb-item passed">Essence</div>
                </Link>
                <Link to='/stucture'>
                  <div className="breadcrumb-item active">Structure</div>
                </Link>
                <Link to='/accessories'>
                  <div className="breadcrumb-item " >Accessoires</div>
                </Link>
                <Link to='/finalization'>
                  <div className="breadcrumb-item">Finalisation</div>
                </Link>
              </div> */}
              <h2 className="title">{title}</h2>
            </div>
          </div>
        </div>
      </section>
        </>
    )
}

export default StepTitle